import { cn } from '@workspace/ui/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import React from 'react';

const cols = {
  '2': 'grid-cols-2',
  '3': 'grid-cols-3',
  '4': 'grid-cols-4',
  '5': 'grid-cols-5',
  '2-3-4': 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-4',
  '2-4': 'grid-cols-2 md:grid-cols-4',
  '2-3': 'grid-cols-2 md:grid-cols-3',
} as const;

const gap = {
  none: 'gap-0',
  sm: 'gap-2',
  md: 'gap-4',
  lg: 'gap-6',
  'sm-md': 'gap-2 md:gap-4',
} as const;

const gridVariants = cva('grid', {
  variants: { cols, gap },
  defaultVariants: {
    cols: '2-4',
    gap: 'sm-md',
  },
});

type GridProps = React.ComponentProps<'div'> &
  VariantProps<typeof gridVariants>;

const Grid = React.forwardRef<HTMLDivElement, GridProps>(
  ({ className, cols, gap, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(gridVariants({ cols, gap, className }))}
      {...props}
    />
  ),
);

Grid.displayName = 'Grid';

export { Grid, gridVariants, cols, gap };
export type { GridProps };
